export default __webpack_public_path__ + "static/media/wordmark_blue.57e3960a.png";